import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../ui/Button';
import { HeartPulse } from 'lucide-react';

export function MarketingNavbar() {
    return (
        <nav className="sticky top-0 z-50 w-full border-b border-slate-100 bg-white/80 backdrop-blur-xl h-20 flex items-center">
            <div className="container mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex items-center justify-between">
                    <Link to="/" className="flex items-center gap-3">
                        <div className="h-10 w-10 rounded-xl bg-brand-600 flex items-center justify-center text-white shadow-premium">
                            <HeartPulse className="h-6 w-6" />
                        </div>
                        <span className="text-2xl font-black tracking-tight text-slate-900 font-outfit uppercase">P2G Life</span>
                    </Link>
                    <div className="hidden md:flex items-center space-x-12">
                        <a href="#features" className="text-[10px] font-black text-slate-400 hover:text-brand-600 transition-colors uppercase tracking-[0.2em]">Features</a>
                        <a href="#stakeholders" className="text-[10px] font-black text-slate-400 hover:text-brand-600 transition-colors uppercase tracking-[0.2em]">Solutions</a>
                        <a href="#contact" className="text-[10px] font-black text-slate-400 hover:text-brand-600 transition-colors uppercase tracking-[0.2em]">Contact</a>
                    </div>
                    <div className="flex items-center space-x-4">
                        <Link to="/login">
                            <Button variant="ghost" className="hidden sm:inline-flex text-[10px] font-black uppercase tracking-widest text-slate-400 hover:text-brand-600 transition-all rounded-xl h-12">Portal Log in</Button>
                        </Link>
                        <Link to="/register">
                            <Button className="shadow-premium hover:shadow-2xl transition-all rounded-xl h-12 px-6 bg-brand-600 hover:bg-brand-700 text-white font-black text-[10px] uppercase tracking-widest border-none">Get Started</Button>
                        </Link>
                    </div>
                </div>
            </div>
        </nav>
    );
}
